import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import logo from '../../assets/logo.png';

function Footer() {
  return (
    <footer className="bg-surface border-t border-white/10 py-12 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          
          {/* Column 1 - Logo, Description & Social */}
          <div className="text-center lg:text-left">
            <div className="flex justify-center lg:justify-start">
              <img src={logo} alt="Shyam Advertising Logo" className="h-16 w-auto mb-3" />
            </div>
            <p className="text-gray-400 text-sm mt-4">25+ years of experience in creating impactful signage and branding solutions across Mumbai.</p>
            
            {/* Social Icons */}
            <div className="flex space-x-4 mt-6 justify-center lg:justify-start">
              <a href="https://facebook.com/shamadvertising101" target="_blank" rel="noopener noreferrer" className="bg-white/5 border border-white/10 hover:bg-brand-orange/20 hover:border-brand-amber/30 p-2 rounded-full transition-all duration-300" aria-label="Facebook">
                <FiFacebook className="text-white text-lg" />
              </a>
              <a href="https://instagram.com/shyam_advertising_101" target="_blank" rel="noopener noreferrer" className="bg-white/5 border border-white/10 hover:bg-brand-orange/20 hover:border-brand-amber/30 p-2 rounded-full transition-all duration-300" aria-label="Instagram">
                <FiInstagram className="text-white text-lg" />
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-brand-orange text-sm transition">Home</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-brand-orange text-sm transition">Services</Link></li>
              <li><Link to="/projects" className="text-gray-400 hover:text-brand-orange text-sm transition">Our Projects</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-brand-orange text-sm transition">About</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-brand-orange text-sm transition">Contact</Link></li>
            </ul>
          </div>

          {/* Column 3 - Our Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">3D Box Letters</li>
              <li className="text-gray-400 text-sm">Channel Letter</li>
              <li className="text-gray-400 text-sm">ACP Board</li>
              <li className="text-gray-400 text-sm">Glow Sign Board</li>
              <li className="text-gray-400 text-sm">Neon Signage</li>
              <li className="text-gray-400 text-sm">LED Panels</li>
            </ul>
          </div>

          {/* Column 4 - Gifting Products */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Gifting Products</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Slim LED Frame</li>
              <li className="text-gray-400 text-sm">Table Top Display</li>
              <li className="text-gray-400 text-sm">Photo Frame</li>
              <li className="text-gray-400 text-sm">Mug</li>
              <li className="text-gray-400 text-sm">Bottle</li>
              <li className="text-gray-400 text-sm">Polo T-shirt</li>
              <li className="text-gray-400 text-sm">Hoodies</li>
              <li className="text-gray-400 text-sm">Cap</li>
            </ul>
          </div>

          {/* Column 5 - Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-400 text-sm">
                <FiPhone className="text-brand-orange mr-3 text-lg" />
                <a href="tel:9821466536" className="hover:text-brand-orange">9821466536</a>
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <FaWhatsapp className="text-brand-orange mr-3 text-xl" />
                <a href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="hover:text-brand-green">WhatsApp: 9821466536</a>
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <FiMail className="text-brand-orange mr-3 text-lg" />
                <a href="mailto:shyamadvertising101@gmail.com" className="hover:text-brand-orange break-all">shyamadvertising101@gmail.com</a>
              </li>
              <li className="flex items-start text-gray-400 text-sm">
                <FiMapPin className="text-brand-orange mr-3 text-xl mt-0.5" />
                <span>SHOP NO 63, V MALL, THAKUR COMPLEX, KANDIVALI (E), MUMBAI - 400101</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-10 pt-6 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} <span className="text-brand-gold">Shyam Advertising</span>. <a href="https://100billiontech.com/ownership" target="_blank" rel="noopener noreferrer" className="text-brand-orange hover:text-brand-yellow transition-colors">All rights reserved.</a> | Designed with <span className="text-brand-red">❤️</span> for creativity by <a href="https://100billiontech.com/" target="_blank" rel="noopener noreferrer" className="text-brand-orange hover:text-brand-yellow transition-colors">100billion Tech</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;